import { render, staticRenderFns } from "./procurement-summary.vue?vue&type=template&id=cbb1047a&"
import script from "./procurement-summary.vue?vue&type=script&lang=js&"
export * from "./procurement-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports